var m = require('mithril');
var prop = require('mithril/stream');
var session = require('../models/session');
var loaders = require('../../layout/components/loaders');
var header = require('../../layout/components/header');
var modal = require('../../layout/components/modal');
var modalForm = require('../../layout/components/modalForm');
var heading = require('../../components/heading');
var groupModal = modalForm(require('../models/group'));
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var dragscroll = require('../../libs/dragscroll');


var component = {};

component.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Groups');
  document.title = 'nimrod | Groups';
  ctrl.newNode = prop(false);
  ctrl.groups = [];
  ctrl.groupsToShow = [];

  ctrl.init = function () {
    loaders.requestWithLoader({
      url: "/api/v1/group",
      method: "GET"
    }).then(function(result){
      result.sort((a, b) => a.name.localeCompare(b.name));
      result.forEach(groupRecord=>{
        groupRecord.membersString = groupRecord.members.map(memberRecord => `${memberRecord.firstName} ${memberRecord.lastName}`).join(', ');
      })
      if(session.user().isSuperuser == true || session.user().isSuperuser == 1){
        ctrl.groups = result;
      }
      else{
        ctrl.groups = result.filter(groupRecord => {
          let member = false;
          groupRecord.members.forEach(memberRecord => {
            if(!member && memberRecord['@rid'] == session.user()['@rid']) member = true
          })
          return member
        })
      }
      ctrl.newNode(true);
    })
  };

  modal.on('closed', ctrl.init);

  ctrl.init();
};

component.onremove = function () {
  modal.off('closed', this.init);
}

component.view = function () {
  var ctrl = this;
  if(!ctrl.groups){
    return m('div');
  }
  return m('div.mh3', [
    m(heading, {label:'Groups', class:'f-subheadline mb3 pb1 display items-center'}, [
      session.user().isSuperuser == true || session.user().isSuperuser == 1 ?
        m('i',{
          class: 'mb2 f2 mr2 ion-plus blue',
          onclick: groupModal.editDialogue.bind(groupModal, {})
        })
        :''
    ]),
    m(paginationWithSearch, {
      data: ctrl.groups,
      newNode: ctrl.newNode,
      dataToShow: ctrl.groupsToShow,
      placeHolder: 'Search group',
      itemsPerPage: 30,
      fieldsToSearch: ['name', 'membersString']
    },[
      m('div.overflow-hidden', [
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate: dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              m('colgroup', [
                m('col', {width: '24%'}),
                m('col', {width: '76%'}),
              ]),
              m('thead', [
                m('tr', [
                  m('th.ph0.tl', 'Name'),
                  m('th.ph0.tl', 'Users'),
                ])
              ]),
              m('tbody', [
                ctrl.groupsToShow.map(function (group) {
                  if (!group['@rid']) {
                    return m('tr', [
                      m('td.tl.pv1.nowrap', [
                        m('label',{style:{'visibility':'hidden'}}, 'No Data')
                      ]),
                      m('td.tl.pv1.truncate'),
                    ])
                  }else{
                    return m('tr', [
                      m('td.tl.pv1.nowrap', m(m.route.Link, {href: '/group/' + group['@rid'].slice(1)}, group.name)),
                      m('td.tl.pv1.truncate', {style: {maxWidth: '1px'}}, group.membersString),
                    ])
                  }

                })
              ])
            ])
          ])
        ])
      ])
    ])
    
  ])
};

module.exports = component;
